import { makeAutoObservable } from 'mobx'
import { type IResponseTag } from 'entities/Tags/api/types'
import { Tag } from 'entities/Tags/model/Tag'
import { TagsApi } from 'entities/Tags/api/tags'

export class TagsStore {
  constructor() {
    makeAutoObservable(this)
  }

  tagsMap: Map<number, Tag> = new Map()

  fetchTags = async (ids: number[]) => {
    const tags = await TagsApi.getTagsById(ids)

    return tags.map((tag) => new Tag(tag))
  }

  getItem = (id: number) => {
    return this.tagsMap.get(id)
  }

  addItems = (tags: IResponseTag[]) => {
    tags.forEach((item) => {
      this.addItem(item)
    })

    return tags.reduce<Tag[]>((state, item) => {
      const tagId = item.id
      const tag = this.getItem(tagId)

      return tag ? [...state, tag] : [...state]
    }, [])
  }

  addItem = (item: IResponseTag) => {
    const id = item.id
    const tag = this.tagsMap.get(id)

    if (tag) {
      tag.syncOrigin({ ...tag.origin, ...item })
    } else {
      const newTag = new Tag(item)
      this.tagsMap.set(newTag.id, newTag)
    }
  }
}
